import { useContext, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Row, Col, Table, Input, Button, Tag, Popconfirm, message, Modal, Form, Divider } from "antd"
import { v4 as uuid } from "uuid"
import { Header } from "../../Header"
import { MyContext } from "../../../App"
import { get, update, save } from "../../../libs/helper"

export function Users() {

      const { AppData, UserData } = useContext(MyContext)
      const navigate = useNavigate()

      const [data, setData] = useState([])
      const [loading, setLoading] = useState(false)
      const [savingId, setSavingId] = useState(null)
      const [createOpen, setCreateOpen] = useState(false)
      const [createLoading, setCreateLoading] = useState(false)

      useEffect(() => {
            (async () => {
                  await loadUsers()
            })()
            // eslint-disable-next-line
      }, [])

      useEffect(() => {
            if (UserData && UserData.isManagement !== 1) {
                  navigate("/")
            }
            // eslint-disable-next-line
      }, [UserData])

      const loadUsers = async () => {
            setLoading(true)
            const params = {
                  brand: "dasher",
                  table: "users",
                  query: {
                        select: "*",
                        order: { first_name: "ASC" }
                  }
            }

            const { status, result } = await get(params, AppData)

            if (status === "success") {
                  setData(result)
            } else {
                  message.error("Unable to load users")
            }

            setLoading(false)
      }

      const handleSave = async (record) => {

            setSavingId(record.id)

            const d = {
                  brand: "dasher",
                  table: "users",
                  data: {
                        where: { id: record.id },
                        data: {
                              first_name: record.first_name,
                              last_name: record.last_name,
                              username: record.username
                        }
                  }
            }

            const result = await update(d, AppData)

            if (result.status === "success") {
                  message.success("User updated")
            } else {
                  message.error("Update failed")
            }

            setSavingId(null)
      }

      const handleRevoke = async (record) => {

            const revokedUsername = `deleted_${record.id}@dasher.uk`

            const d = {
                  brand: "dasher",
                  table: "users",
                  data: {
                        where: { id: record.id },
                        data: {
                              username: revokedUsername,
                              status: 0,
                              password: "xxx"
                        }
                  }
            }

            const result = await update(d, AppData)

            if (result.status === "success") {
                  message.success("User revoked")
                  await loadUsers()
            } else {
                  message.error("Revoke failed")
            }
      }

      const handleCreate = async (values) => {

            setCreateLoading(true)

            try {

                  const id = uuid()

                  const d = {
                        brand: "dasher",
                        table: "users",
                        data: {
                              id,
                              first_name: values.first_name,
                              last_name: values.last_name,
                              username: values.username,
                              password: "placeholder",
                              status: 1,
                              myPermission: 1,
                              adminPermission: 1,
                              isManagement: 0
                        }
                  }

                  const result = await save(d, AppData)

                  if (result.status === "success") {
                        message.success("User created. Ask them to log in and use 'Forgot your password?'.")
                        setCreateOpen(false)
                        await loadUsers()
                  } else {
                        message.error("Create failed")
                  }

            } catch (err) {

                  console.log(err)
                  message.error("Create failed")

            }

            setCreateLoading(false)
      }

      if (!UserData?.isManagement) {
            return null
      }

      const activeUsers = data.filter(u => u.status === 1)
      const revokedUsers = data.filter(u => u.status !== 1)

      const activeColumns = [
            {
                  title: "First Name",
                  dataIndex: "first_name",
                  key: "first_name",
                  render: (text, record) => (
                        <Input
                              value={text}
                              onChange={(e) => {
                                    const value = e.target.value
                                    setData((prev) =>
                                          prev.map((u) => (u.id === record.id ? { ...u, first_name: value } : u))
                                    )
                              }}
                        />
                  )
            },
            {
                  title: "Last Name",
                  dataIndex: "last_name",
                  key: "last_name",
                  render: (text, record) => (
                        <Input
                              value={text}
                              onChange={(e) => {
                                    const value = e.target.value
                                    setData((prev) =>
                                          prev.map((u) => (u.id === record.id ? { ...u, last_name: value } : u))
                                    )
                              }}
                        />
                  )
            },
            {
                  title: "Username",
                  dataIndex: "username",
                  key: "username",
                  render: (text, record) => (
                        <Input
                              value={text}
                              onChange={(e) => {
                                    const value = e.target.value
                                    setData((prev) =>
                                          prev.map((u) => (u.id === record.id ? { ...u, username: value } : u))
                                    )
                              }}
                        />
                  )
            },
            {
                  title: "Management",
                  dataIndex: "isManagement",
                  key: "isManagement",
                  render: (value) => (
                        value === 1 ? <Tag color="gold">Yes</Tag> : <Tag>No</Tag>
                  )
            },
            {
                  title: "Actions",
                  key: "actions",
                  render: (_, record) => (
                        <>
                              <Button
                                    type="link"
                                    onClick={() => handleSave(record)}
                                    loading={savingId === record.id}
                              >
                                    Save
                              </Button>
                              <Popconfirm
                                    title="Revoke this user?"
                                    okText="Yes"
                                    cancelText="No"
                                    onConfirm={() => handleRevoke(record)}
                              >
                                    <Button type="link" danger>
                                          Revoke
                                    </Button>
                              </Popconfirm>
                        </>
                  )
            }
      ]

      return (

            <>
                  <Header />
                  <div id="content" className="section">
                        <Row justify="center">
                              <Col span={22}>
                                    <Row className="pagetitle">
                                          <Col flex="auto">
                                                <h1>Users</h1>
                                          </Col>
                                          <Col>
                                                <Button size="small" type="primary" onClick={() => setCreateOpen(true)}>
                                                      Create User
                                                </Button>
                                          </Col>
                                    </Row>

                                    <div className="card">
                                          <h2>Active Users</h2>
                                          <Table
                                                rowKey="id"
                                                loading={loading}
                                                dataSource={activeUsers}
                                                columns={activeColumns}
                                                pagination={{ defaultPageSize: 25 }}
                                          />
                                    </div>

                                    <Divider />

                                    <div className="card">
                                          <h2>Revoked Users</h2>
                                          <Table
                                                rowKey="id"
                                                loading={loading}
                                                dataSource={revokedUsers}
                                                columns={[
                                                      {
                                                            title: "First Name",
                                                            dataIndex: "first_name",
                                                            key: "first_name",
                                                            render: (text) => <span style={{ color: "rgba(0,0,0,0.45)" }}>{text}</span>
                                                      },
                                                      {
                                                            title: "Last Name",
                                                            dataIndex: "last_name",
                                                            key: "last_name",
                                                            render: (text) => <span style={{ color: "rgba(0,0,0,0.45)" }}>{text}</span>
                                                      },
                                                      {
                                                            title: "Username",
                                                            dataIndex: "username",
                                                            key: "username",
                                                            render: (text) => <span style={{ color: "rgba(0,0,0,0.45)" }}>{text}</span>
                                                      },
                                                      {
                                                            title: "Management",
                                                            dataIndex: "isManagement",
                                                            key: "isManagement",
                                                            render: (value) => (
                                                                  value === 1 ? <Tag color="gold">Yes</Tag> : <Tag>No</Tag>
                                                            )
                                                      },
                                                      {
                                                            title: "Status",
                                                            dataIndex: "status",
                                                            key: "status",
                                                            render: () => <Tag color="red">Revoked</Tag>
                                                      }
                                                ]}
                                                pagination={{ defaultPageSize: 25 }}
                                          />
                                    </div>
                              </Col>
                        </Row>
                  </div>

                  <Modal
                        title="Create User"
                        open={createOpen}
                        onCancel={() => setCreateOpen(false)}
                        footer={null}
                  >
                        <Form layout="vertical" onFinish={handleCreate}>
                              <Form.Item
                                    label="First Name"
                                    name="first_name"
                                    rules={[{ required: true, message: "Please enter a first name" }]}
                              >
                                    <Input />
                              </Form.Item>
                              <Form.Item
                                    label="Last Name"
                                    name="last_name"
                                    rules={[{ required: true, message: "Please enter a last name" }]}
                              >
                                    <Input />
                              </Form.Item>
                              <Form.Item
                                    label="Email"
                                    name="username"
                                    rules={[{ required: true, message: "Please enter an email" }]}
                              >
                                    <Input />
                              </Form.Item>
                              <Form.Item>
                                    <Button type="primary" htmlType="submit" loading={createLoading}>
                                          Create User
                                    </Button>
                              </Form.Item>
                        </Form>
                  </Modal>
            </>
      )

}

